import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Progress, message } from 'antd'
import { createUseStyles } from 'react-jss'
import { useDispatch } from 'react-redux'
import useInterval from '../../hooks/useInterval'
import api from '../../api'
import { addProgress, finish } from '../../redux/slices/excel'
import { downloadExcelFile } from '../../lib/download'

const REFETCHING_TIME = 5000

const useStyles = createUseStyles(theme => ({
  label: {
    lineHeight: '0.75',
    color: 'white',
    fontSize: '13px',
  },
  container: {
    marginTop: '12px',
    '&:first-child': {
      marginTop: 0,
    },
  },
}))

const progressStatus = {
  finished: 'success',
  loading: 'active',
  error: 'exception',
}

function ExcelProgress({ archiveId, initialProgress }) {
  const [buildingExcel, setBuildingExcel] = useState('loading')
  const [currentProgress, setCurrentProgress] = useState(initialProgress)
  const classes = useStyles()
  const dispatch = useDispatch()

  const getExcelProgress = async () => {
    try {
      const {
        progress,
        finishedAt,
        error,
        fileUrl,
        fileName,
      } = await api.patients.getExcelStatus(archiveId)

      const percent = progress || 0
      setCurrentProgress(percent)
      dispatch(addProgress(archiveId, percent))

      if (error) {
        setBuildingExcel('error')
        message.error(`Something went wrong: ${error}`)
        dispatch(finish(archiveId))
      } else if (finishedAt && percent >= 100) {
        await downloadExcelFile(fileUrl, fileName)
        setBuildingExcel('finished')
        message.success(
          'The Excel file has been generated. Download will start soon.',
        )
        setTimeout(() => {
          dispatch(finish(archiveId))
        }, 1000)
      }
    } catch (err) {
      setBuildingExcel('error')
      dispatch(finish(archiveId))
      message.error(`Something went wrong: ${err.message}`)
    }
  }

  useInterval(
    getExcelProgress,
    buildingExcel === 'loading' ? REFETCHING_TIME : null,
  )

  return (
    <div className={classes.container}>
      <div className={classes.label}>
        {buildingExcel === 'loading' && 'Generating Excel file...'}
        {buildingExcel === 'finished' &&
          'The Excel file has been generated and an email has been sent.'}
        {buildingExcel === 'error' &&
          'There was an error generating the Excel file.'}
      </div>
      <Progress
        percent={currentProgress}
        status={progressStatus[buildingExcel]}
      />
    </div>
  )
}

ExcelProgress.propTypes = {
  archiveId: PropTypes.string.isRequired,
  initialProgress: PropTypes.number,
}

ExcelProgress.defaultProps = {
  initialProgress: 0,
}

export default ExcelProgress
